import { studentExercisesResultInitState } from './InitState';
import { IAction } from '../../../../../__core/Interfaces/IAction';
import { StudentExercisesResultResponse } from '../Types/StudentExercisesResultResponse';
import CURSE_INSTANCE_ACTIONS from '../../../Actions/ActionTypes';

export const studentExercisesResultReducer = (
  state: StudentExercisesResultResponse = studentExercisesResultInitState,
  action: IAction<StudentExercisesResultResponse>
): StudentExercisesResultResponse => {
  switch (action.type) {
    case CURSE_INSTANCE_ACTIONS.FETCH_STUDENTS_EXERCISES_RESULT:
      return { ...action.payload };

    default:
      return state;
  }
};
